const currencySymbol = (code: string): string => {
  switch (code) {
    case 'GBP':
      return '£';
    case 'USD':
      return '$';
    case 'EUR':
      return '€';
    default:
      return code;
  }
};

export default currencySymbol;
